import { Helmet } from 'react-helmet';

const Head = ({ ...props }) => (
  <Helmet>
    <title>
      {props.title ? `${props.title} | ` : null} DashLite React Admin Template
    </title>
  </Helmet>
);
export default Head;
